import type { Notification } from './notification';

/** Figma 예시 2건(File · 읽지 않음, Memo · 읽음) */
export const notificationFixture = {
  unread: {
    id: 301,
    portfolioId: 12,
    portfolioName: '부분회수 케이스 A',
    notifiedAt: '2026-09-25T14:30:00+09:00',
    type: 'File',
    content: '[부분회수 케이스 A] 2026년 3분기 재무상태표가 업로드되었습니다.',
    isRead: false,
  },
  read: {
    id: 298,
    portfolioId: 17,
    portfolioName: '투자중 케이스 D',
    notifiedAt: '2026-09-24T09:12:00+09:00',
    type: 'Memo',
    content:
      '[투자중 케이스 D] 임꺽정 심사역이 메모를 남겼습니다: 시리즈 B 후속 투자 검토를 위해 10월 첫째 주 경영진 미팅을 잡았습니다. 3분기 매출 자료를 먼저 요청해 주세요.',
    isRead: true,
  },
} satisfies Record<string, Notification>;

export const notificationListFixture: Notification[] = [
  notificationFixture.unread,
  notificationFixture.read,
];
